import React from 'react';
const Servings = ({ servings }) => {
    if (servings) {
      return <p className="recipe-servings"><i className="material-icons">restaurant</i>{servings}x</p>
    }
    return null;
  }
export default Servings